import React from 'react';
import {useQuery} from 'react-query';
import {api, truncate, url} from '../../helpers';
import {PrimaryButton} from 'components';

function getLatestBlogPost() {
  return api.get('/blog?status=published&limit=1').then(res => res.data);
}

export default function QuickActionsDynamicCard({lighterShade}) {
  const {data} = useQuery('latest-blog-post', getLatestBlogPost);

  return (
    <div className="flex flex-col lg:flex-row rounded-xl shadow-cards">
      <div
        style={{
          backgroundColor: lighterShade,
          borderColor: 'rgba(230, 240, 255, 0.5)',
        }}
        className="flex-1 p-6 lg:p-[42px] rounded-t-xl lg:rounded-l-xl lg:rounded-r-none"
      >
        <p className="text-small w-fit py-1 px-2 text-[#DC6803] bg-[#FFFAF0] rounded-full font-medium">
          Blog post
        </p>
        <p className="mt-2 text-base text-deepBlue font-semibold">
          {data?.posts?.[0]?.title}
        </p>
        <p className="mt-2 text-sm text-body max-w-[335px]">
          {truncate(data?.posts?.[0]?.summary, 130)}
        </p>
        <a
          href={`${url}/blog/${data?.posts[0]?.slug}`}
          target="_blank"
          rel="noreferrer"
        >
          <PrimaryButton buttonText="Read More" className="mt-2" />
        </a>
      </div>

      <img
        src={data?.posts[0]?.cover_img}
        alt=""
        className="rounded-b-xl lg:rounded-r-xl lg:rounded-l-none w-full lg:w-[260px] object-cover"
      />
    </div>
  );
}
